<div class="fonts">
  @for (group of fontGroups; track group.name) {
    <div class="group">
      <div class="title">{{ group.label | translate }}</div>
      <div class="items">
        @for (font of group.fonts; track font) {
          <div class="item"
               [class.active]="fontName === font"
               (click)="setFontName(font)">
            <img [src]="getFontPreviewUrl(font)" [alt]="font" [title]="font">
          </div>
        }
      </div>
    </div>
  }
</div>
